import React from 'react'
import { MenuItem, Position } from '@blueprintjs/core'
import { Select2 } from '@blueprintjs/select'
import { Button, IconButton } from '@ui'
import ClearableSelectWrapper from '@ui/selects/ClearableSelectWrapper'
import { get } from 'lodash'
import { IUIButtonProps } from '@ui/buttons/Button'
import { TicketStatus } from '@api/types'

export interface IStatus {
  label: string
  value: TicketStatus
}

interface StatusSelectProps {
  buttonProps?: IUIButtonProps
  placeholder?: string
  value: IStatus | null
  clearable?: boolean
  onChange: (status: IStatus | null) => void
}

export const TICKET_STATUSES = [
  { label: 'New', value: TicketStatus.NEW },
  { label: 'Open', value: TicketStatus.OPEN },
  {
    label: 'In Progress',
    value: TicketStatus.INPROGRESS,
  },
  { label: 'On Hold', value: TicketStatus.ONHOLD },
  { label: 'Closed', value: TicketStatus.CLOSED },
  { label: 'Assigned', value: TicketStatus.ASSIGNED },
  { label: 'Resolved', value: TicketStatus.RESOLVED },
  { label: 'Cancelled', value: TicketStatus.CANCELED },
  { label: 'Pending', value: TicketStatus.PENDING },
  { label: 'Error', value: TicketStatus.ERROR },
]

export function getTicketStatus(status: TicketStatus): IStatus {
  return TICKET_STATUSES.find(({ value }) => value === status) || TICKET_STATUSES[0]
}

const StatusSelect = Select2<IStatus>

export default function StatusSelectWrapper({
  clearable,
  value,
  placeholder,
  onChange,
  buttonProps,
}: StatusSelectProps) {
  return (
    <>
      <StatusSelect
        popoverProps={{
          position: Position.BOTTOM,
          minimal: true,
        }}
        filterable={false}
        items={TICKET_STATUSES}
        itemRenderer={(status, { handleClick }) => (
          <MenuItem
            key={status.value}
            active={value ? status.value === value.value : false}
            onClick={handleClick}
            text={status.label}
            data-item={status.label}
          />
        )}
        onItemSelect={onChange}>
        <Button
          {...buttonProps}
          rightIconName={!get(buttonProps, 'iconName') && !value ? 'chevron-down' : undefined}
          text={value ? value.label : placeholder || 'Select'}
        />
      </StatusSelect>
      {value && clearable && (
        <IconButton minimal iconName="times" tooltip="Clear" onClick={() => onChange(null)} />
      )}
    </>
  )
}
